export const initDeleteAccount =  item => ({ type: "ADD_TO_DELETE_QUEUE", item: item });

export const undoDeleteAccount =  () => {
    return { type: "UNDO_ACCOUNT"};
}